import { Box, Typography } from "@mui/material";
import { BellOff } from "lucide-react";

export interface NotificationsEmptyProps {
    onlyUnread?: boolean;
}

export const NotificationsEmpty = ({ onlyUnread }: NotificationsEmptyProps) => (
    <Box sx={{ textAlign: "center", py: 6, px: 2, color: "text.secondary" }}>
        <BellOff size={32} style={{ opacity: 0.5 }} />
        <Typography variant="body2" sx={{ mt: 1.5 }}>
            {onlyUnread ? "Estás al día." : "No tienes notificaciones."}
        </Typography>
    </Box>
);
